import { post } from "@/utils/utils";
const offLineReport = {
    mutations: {
        QUERY_REFUND_DATA(state, data) {
            state.queryRefundData = data.result;
        },
        QUERY_PAY_DATA(state, data) {
            state.queryPayData = data.result;
        },
        QUERY_LIVE_DATA(state, data) {
            state.queryLiveData = data.result;
        },
        QUERY_GOODS_DATA(state, data) {
            state.queryGoodsData = data.result;
        },
        QUERY_DATA_FLOW(state, data) {
            state.queryDataFlow = data.result;
        },
        QUERY_GROSS_DATA(state, data) {
            state.queryGrossData = data.result;
        },
        QUERY_MEMBER_ACTIVE_DATA(state, data) {
            state.queryMemberActiveData = data.result;
        },
        QUERY_MEMBER_DATA(state, data) {
            state.queryMemberData = data.result;
        },
        QUERY_ADD_GOODS_DATA(state, data) {
            state.queryAddGoodsData = data.result;
        },
        QUERY_SHARE_MEMBER_DATA(state, data) {
            state.queryShareMemberData = data.result;
        },
        QUERY_SHARE_COMMISSION_DATA(state, data) {
            state.queryShareCommissionData = data.result;
        },
        DATA_TIP(state, data) {
            state.queryShareCommissionData = data.result;
        },
        GENERAL_REPORTS_CATEGORY() {},
        GENERAL_REPORTS_TOP_BRAND_BY_PRICE() {},
        GENERAL_REPORTS_TOP_BRAND_BY_NUM() {},
        GENERAL_REPORTS_TOP_SKU_BY_PRICE() {},
        GENERAL_REPORTS_TOP_SKU_BY_NUM() {},
    },
    actions: {
        queryRefundData({commit}, params) {
            return post({
                commit,
                url: `/generalReports/queryRefundData`,
                name: "QUERY_REFUND_DATA",
                params
            });
        },
        queryPayData({commit}, params) {
            return post({
                commit,
                url: `/generalReports/queryPayData`,
                name: "QUERY_PAY_DATA",
                params
            });
        },
        queryLiveData({commit}, params) {
            return post({
                commit,
                url: `/generalReports/queryLiveData`,
                name: "QUERY_LIVE_DATA",
                params
            });
        },
        queryGoodsData({commit}, params) {
            return post({
                commit,
                url: `/generalReports/queryRptBizSummaryData`,
                name: "QUERY_GOODS_DATA",
                params
            });
        },
        queryDataFlow({commit}, params) {
            return post({
                commit,
                url: `/generalReports/queryVisitData`,
                name: "QUERY_DATA_FLOW",
                params
            });
        },
        queryGrossData({commit}, params) {
            return post({
                commit,
                url: `/generalReports/queryRptBizSummaryComplexDataByBizType`,
                name: "QUERY_GROSS_DATA",
                params
            });
        },
        queryMemberActiveData({commit}, params) {
            return post({
                commit,
                url: `/generalReports/queryMemberActiveData`,
                name: "QUERY_MEMBER_ACTIVE_DATA",
                params
            });
        },
        queryMemberData({commit}, params) {
            return post({
                commit,
                url: `/generalReports/queryMemberData`,
                name: "QUERY_MEMBER_DATA",
                params
            });
        },
        queryAddGoodsData({commit}, params) {
            return post({
                commit,
                url: `/generalReports/queryAddGoodsData`,
                name: "QUERY_ADD_GOODS_DATA",
                params
            });
        },
        queryShareMemberData({commit}, params) {
            return post({
                commit,
                url: `/generalReports/queryShareMemberData`,
                name: "QUERY_SHARE_MEMBER_DATA",
                params
            });
        },
        queryShareCommissionData({commit}, params) {
            return post({
                commit,
                url: `/generalReports/queryShareCommissionData`,
                name: "QUERY_SHARE_COMMISSION_DATA",
                params
            });
        },
        dataTip({commit}, params) {
            return post({
                commit,
                url: `/sys/common/getUiPopoverByPopoverCodeLeftLike?popoverCode=data_`,
                name: "DATA_TIP",
                params
            });
        },
        //分类销售概况
        generalReportsCategory({commit}, params) {
            return post({
                commit,
                url: `/generalReports/category`,
                name: "GENERAL_REPORTS_CATEGORY",
                params
            });
        },
        //品牌销售额TOP50
        generalReportsTopBrandByPrice({commit}, params) {
            return post({
                commit,
                url: `/generalReports/topBrandByPrice`,
                name: "GENERAL_REPORTS_TOP_BRAND_BY_PRICE",
                params
            });
        },
        //品牌销售量TOP50
        generalReportsTopBrandByNum({commit}, params) {
            return post({
                commit,
                url: `/generalReports/topBrandByNum`,
                name: "GENERAL_REPORTS_TOP_BRAND_BY_NUM",
                params
            });
        },
        //单品SKU销售额top100
        generalReportsTopSkuByPrice({commit}, params) {
            return post({
                commit,
                url: `/generalReports/topSkuByPrice`,
                name: "GENERAL_REPORTS_TOP_SKU_BY_PRICE",
                params
            });
        },
        //单品SKU销售量top100
        generalReportsTopSkuByNum({commit}, params) {
            return post({
                commit,
                url: `/generalReports/topSkuByNum`,
                name: "GENERAL_REPORTS_TOP_SKU_BY_NUM",
                params
            });
        },
    }
}

export default offLineReport;
